import * as api from "../../api/index";
import * as endpoints from "../../api/endpoints";
import * as types from "../../api/../mutation-types";

const actions = {
  getSmContractsPurchaseSales({ commit }, payload) {
    return api.fetchFull(endpoints.SM_CONTRACTS_PURCHASE_SALE, payload, commit, (response) => {
      return response;
    });
  },

  getSmContractsPurchaseSaleDetails({ commit }, payload) {
    return api.fetchFull(endpoints.SM_CONTRACTS_PURCHASE_SALE_DETAILS, payload, commit, (response) => {
      return response;
    });
  },

  getSmContractsPurchaseSalesByUuid({ commit }, payload) {
    return api.fetchFull(endpoints.SM_CONTRACTS_PURCHASE_SALE + "/" + payload.uuid, payload, commit, (response) => {
      return response;
    });
  },

  createSmContractsPurchaseSale({ commit }, payload) {
    return api.post(endpoints.SM_CONTRACTS_PURCHASE_SALE, payload, commit, (response) => {
      return response;
    });
  },

  updateSmContractsPurchaseSale({ commit }, payload) {
    return api.put(endpoints.SM_CONTRACTS_PURCHASE_SALE + "/" + payload.uuid, payload, commit, (response) => {
      return response;
    });
  },

  deleteSmContractsPurchaseSale({ commit }, payload) {
    return api.remove(endpoints.SM_CONTRACTS_PURCHASE_SALE + "/" + payload.uuid, payload, commit, (response) => {
      return response;
    });
  },

  getSmContractsPurchaseSaleTypes({ commit }, payload) {
    return api.fetchFull(endpoints.SM_CONTRACTS_PURCHASE_SALE_TYPES, payload, commit, (response) => {
      commit(types.SET_SM_CONTRACTS_PURCHASE_SALE_TYPES, response.data);
      return response;
    });
  },
};

export default actions;
